import React from 'react'
import styles from './ChatSection.module.css'

export default function ChatSection({ message }) {
  return (
    <div className={styles.root}>
      <div className={styles.message}>
        <span className={styles.triangle_top_right} />
        <p className={styles.message_body}>{message}</p>
      </div>
    </div>
  )
}
